import { useState } from "react";
import { Button } from "../shared/button";
import { ConfirmDialog } from "../shared/confirm-dialog";
import { apiPost, apiDelete, endpoints } from "../../api/client";
import { useMerchantStore } from "../../store/merchant";

export function SquareConnection() {
  const { appMerchantId, businessName, connected, clearMerchant } =
    useMerchantStore();
  const [disconnecting, setDisconnecting] = useState(false);
  const [showDisconnectConfirm, setShowDisconnectConfirm] = useState(false);
  const [disconnectError, setDisconnectError] = useState<string | null>(null);
  const [connectError, setConnectError] = useState<string | null>(null);

  async function handleConnect() {
    setConnectError(null);
    try {
      const res = await apiPost<{ authorizationUrl: string }>(endpoints.squareConnect);
      window.location.href = res.authorizationUrl;
    } catch (err) {
      setConnectError(
        err instanceof Error ? err.message : "Failed to start connection",
      );
    }
  }

  async function handleDisconnect() {
    if (!appMerchantId) return;
    setDisconnectError(null);
    setDisconnecting(true);
    try {
      await apiDelete(endpoints.squareDisconnect(appMerchantId));
      clearMerchant();
    } catch (err) {
      setDisconnectError(
        err instanceof Error ? err.message : "Failed to disconnect",
      );
    } finally {
      setDisconnecting(false);
    }
  }

  return (
    <div className="card">
      <div className="clabel">Square Account</div>
      {connected ? (
        <>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              padding: "10px 12px",
              background: "var(--green-bg)",
              border: "1px solid var(--green-bd)",
              borderRadius: "10px",
              marginBottom: "12px",
            }}
          >
            <span style={{ fontSize: "20px" }}>&#x2705;</span>
            <div>
              <div style={{ fontSize: "13px", fontWeight: 700, color: "var(--green)" }}>
                Square Connected
              </div>
              {businessName && (
                <div style={{ fontSize: "11px", color: "var(--green)", marginTop: "2px" }}>
                  {businessName}
                </div>
              )}
            </div>
          </div>
          <Button
            variant="red"
            full
            onClick={() => setShowDisconnectConfirm(true)}
            disabled={disconnecting}
          >
            {disconnecting ? "Disconnecting..." : "Disconnect Square Account"}
          </Button>
          {disconnectError && (
            <div
              style={{
                marginTop: "8px",
                color: "var(--red)",
                fontSize: "13px",
                fontWeight: 600,
              }}
            >
              {disconnectError}
            </div>
          )}
        </>
      ) : (
        <>
          <div
            style={{
              fontSize: "13px",
              color: "var(--ink2)",
              lineHeight: 1.6,
              marginBottom: "14px",
            }}
          >
            Connect your Square account to allow Simple Cash Discount to access your
            catalog, process payments, and sync with your Terminal.
          </div>
          {connectError && (
            <div
              style={{
                marginBottom: "10px",
                color: "var(--red)",
                fontSize: "13px",
                fontWeight: 600,
              }}
            >
              {connectError}
            </div>
          )}
          <Button variant="gradient" full onClick={handleConnect}>
            Connect with Square
          </Button>
        </>
      )}
      <ConfirmDialog
        open={showDisconnectConfirm}
        title="Disconnect Square?"
        message="You'll need to reconnect to use Simple Cash Discount. Your stored OAuth tokens will be deleted."
        confirmLabel="Disconnect"
        variant="destructive"
        onConfirm={() => {
          setShowDisconnectConfirm(false);
          handleDisconnect();
        }}
        onCancel={() => setShowDisconnectConfirm(false)}
      />
    </div>
  );
}
